import React, {useState} from 'react';
import Breadcrumb from '../../../common/breadcrumb';
import FootageProductionReportFilters from "./footageProductionReportFilters";
import LoadingIndicator from "../../../common/loadingIndicator";

/**
 * Footage Production Report
 * @returns {JSX.Element}
 * @constructor
 */
const FootageProductionReport = () => {
    const [isLoading, setIsLoading] = useState(false);

    return (
        <>
            <Breadcrumb title="Footage Production Report" parent="Reports"/>
            <FootageProductionReportFilters setIsLoading={setIsLoading} />
            <LoadingIndicator isLoading={isLoading}/>
        </>
    );
}

export default FootageProductionReport;
